import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import NotFound404 from '../components/ErrorPageComponent/404';
import { useTranslation } from 'react-i18next';
import ContactPromoGeneralLayout from '../components/ContactPageComponents/PagesComponents/ContactPromoGeneralLayout';
import Clients from '../components/BrandSection/Clients';
import { useCachedFetch } from '../hooks/useCachedFetch';

const ContactPromoGeneralWrapper = ({ hideHeaderFooterSetter, hideLanguageSwitcherSetter }) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const promoCode = query.get('promocode');

  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [validPromoCodes, setValidPromoCodes] = useState([]);

  useEffect(() => {
    if (hideLanguageSwitcherSetter) {
      hideLanguageSwitcherSetter(true);
    }
    return () => {
      if (hideLanguageSwitcherSetter) {
        hideLanguageSwitcherSetter(false);
      }
    };
  }, [hideLanguageSwitcherSetter]);

  const { data: promoData, loading, error } = useCachedFetch('/data/locales/promo.json');

  useEffect(() => {
    if (loading) return;
    
    if (error) {
      console.error('Error loading promo data:', error);
      setHasError(true);
      setIsLoading(false);
      return;
    }

    const data = promoData?.comingSoonData;

    if (data && data.length > 0) {
      const allPromoCodes = data.map(item => {
        const translations = item.translations?.[currentLang] || item.translations?.en || {};
        return translations.promoPageInfo?.mainPromocode;
      }).filter(Boolean);

      setValidPromoCodes(allPromoCodes);

      const foundItem = data.find(item => {
        const translations = item.translations?.[currentLang] || item.translations?.en || {};
        return translations.promoPageInfo?.mainPromocode === promoCode;
      });

      if (foundItem) {
        setCurrentItem(foundItem);
        setHasError(false);
      } else {
        setHasError(true);
      }
    } else {
      setHasError(true);
    }
    
    setIsLoading(false);
  }, [promoData, loading, error, promoCode, currentLang]);

  if (isLoading) {
    return null;
  }

  if (hasError || !promoCode || !validPromoCodes.includes(promoCode) || !currentItem) {
    return <NotFound404 hideHeaderFooterSetter={hideHeaderFooterSetter} />;
  }

  const currentTranslations = currentItem.translations?.[currentLang] || currentItem.translations?.en || {};

  return (
    <>
      <ContactPromoGeneralLayout
        promoCode={currentTranslations.promoPageInfo?.mainPromocode}
        hideHeaderFooterSetter={hideHeaderFooterSetter}
        hideLanguageSwitcherSetter={hideLanguageSwitcherSetter}
      />
      <Clients />
    </>
  );
};

export default ContactPromoGeneralWrapper;